import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlantListInterface } from 'src/app/pages/record/interfaces';
import { environment } from 'src/environments/environment';
import { EndpointConstants } from 'src/app/core/services/endpoints-configurations/endpoint-constants';
import { ProjectSettingsService } from 'src/app/core/services/common/project-settings.service';
import { Store } from '@ngrx/store';
import { getLoginInfo } from '../login/login.selectors';
import { filter, take, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PlantListCompanyByUserGuidService {
  options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };

  constructor(
    private http: HttpClient,
    private settings: ProjectSettingsService,
    private store: Store<Store>,
  ) {}

  getPlantListByCompanyByUserGuid(): Observable<PlantListInterface[]> {
    return this.store.select(getLoginInfo).pipe(
      filter((loginInfo) => !!loginInfo),
      take(1),
      switchMap((loginInfo) => {
        const key = Object.keys(loginInfo)?.[0];

        if (key) {
          const info = loginInfo[key];
          const userGuid = info.UserGuid;
          const url = this.settings.generateEndpoint(EndpointConstants.ApiPlantsByCompany + '?userGuid=' + userGuid);
          const request = { CompanyGuid: info.CompanyGuid };
          return this.http.post<PlantListInterface[]>(url, request, this.options);
        } else {
          return of(null);
        }
      }),
    );
  }
}
